import * as React from 'react'
import { styleguide } from 'styleguide'
export default props => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 100 100"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <defs>
      <rect
        id="api-icon-path-3"
        x="-27"
        y="-2"
        width="146"
        height="28"
        rx="14"
      />
    </defs>
    <g
      id="api-icon-Desktop-Copy-3"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd">
      <g id="api-icon-Group-44">
        <g id="api-icon-Group-32">
          <use id="api-icon-Mask" fill="#FFFFFF" xlinkHref="#api-icon-path-1" />
          <g id="api-icon-Rectangle-8" mask="url(#mask-2)">
            <use
              fill={styleguide.colors.secondary}
              fill-rule="evenodd"
              xlinkHref="#api-icon-path-3"
            />
            <rect
              stroke={styleguide.colors.subtext}
              stroke-width="3"
              x="-26"
              y="-1"
              width="144"
              height="26"
              rx="13"
            />
          </g>
          <rect
            id="api-icon-Rectangle-15-Copy"
            fill={styleguide.colors.primary}
            mask="url(#mask-2)"
            x="14"
            y="55"
            width="33"
            height="5"
          />
          <g
            id="api-icon-Group-30"
            mask="url(#mask-2)"
            fill={styleguide.colors.foreground}>
            <g
              transform="translate(14.000000, 70.000000)"
              id="api-icon-Rectangle-15-Copy">
              <rect x="0" y="0" width="17.9565217" height="5" />
              <rect x="23.0869565" y="0" width="35.9130435" height="5" />
            </g>
          </g>
          <g
            id="api-icon-Group-31"
            mask="url(#mask-2)"
            fill={styleguide.colors.foreground}>
            <g
              transform="translate(14.000000, 40.000000)"
              id="api-icon-Rectangle-15">
              <rect x="0" y="0" width="29.46875" height="5" />
              <rect x="34.59375" y="0" width="6.40625" height="5" />
            </g>
          </g>
          <circle
            id="api-icon-Oval"
            fill="#FB5B5B"
            mask="url(#mask-2)"
            cx="18.5"
            cy="12.5"
            r="4.5"
          />
          <circle
            id="api-icon-Oval"
            fill="#FBCA5B"
            mask="url(#mask-2)"
            cx="31.5"
            cy="12.5"
            r="4.5"
          />
          <circle
            id="api-icon-Oval"
            fill="#AFF38C"
            mask="url(#mask-2)"
            cx="43.5"
            cy="12.5"
            r="4.5"
          />
        </g>
      </g>
    </g>
  </svg>
)



// WEBPACK FOOTER //
// ./src/components/Sections/HowItWorks/Icon/ApiSvg.jsx